// Generated from SVG to Code Figma Plugin

export const LogoDark = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={`${443 / 127}em`}
    height="1em"
    fill="none"
    viewBox="0 0 443 137"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_192_1879)">
      <path
        d="M145.98 1.83999C125.33 -5.00001 107.57 9.50999 103.43 22.79C103.43 22.79 88.53 70.64 82.18 90.61C79.15 100.13 71.64 115.72 57.5 115.72C45.98 115.72 40.06 104.91 37.56 98.47L20.39 52.69C18.4 47.87 20.48 38.25 28.46 35.37C36.98 32.31 42.46 39.44 43.88 43.22L65.27 98.02C70.37 91.45 73.61 80.76 75.72 73.19L61.67 36.31C55.01 19.1 37.4 11.28 21.08 17.29C7.85998 22.16 -4.86002 38.84 2.05998 59.8L19.78 105.38C22.47 112.29 33.1 134.85 57.12 134.85C85.95 134.85 96.77 110.27 102.77 90.84C105.77 81.12 122.23 28.57 122.23 28.57C124.62 20.72 134.34 18.46 140.41 20.44C144.69 21.83 152.43 27.74 149.93 36.9C149.46 38.57 136.34 80.85 131.5 93.71C128.97 100.42 122.56 114.99 107.97 112.96C103.52 122.81 99.83 128.53 94.24 133.67C112.44 142.29 138.97 133.61 150.14 99.86C154.29 87.31 168.86 42.06 168.86 42.06C173.09 28.16 165.54 8.30999 145.98 1.83999Z"
        fill="url(#paint0_linear_192_1879)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M294.23 34.07C294.23 38.6926 290.483 42.44 285.86 42.44C281.237 42.44 277.49 38.6926 277.49 34.07C277.49 29.4473 281.237 25.7 285.86 25.7C290.483 25.7 294.23 29.4473 294.23 34.07ZM333.91 53.07C318.43 53.07 306.31 67.72 306.31 85.74C306.31 104.67 317.64 118.41 333.91 118.41C342.14 118.41 350.74 114.24 355.83 107.79L356.66 106.74V116.22H370.52V31.61H356.66V65.76C349.52 57.5 342.71 53.07 333.91 53.07ZM356.7 79.79V92.4C356.7 96.08 351.07 105.76 338.4 105.76C328.59 105.76 321.2 97.1 321.2 85.61C321.2 74.24 328.76 65.33 338.4 65.33C350.41 65.34 356.7 76.08 356.7 79.79ZM222.86 116.08L194.6 33.9399H209.04L231.29 98.2999L253.53 33.9399H267.98L239.72 116.08H222.86ZM429.06 116.33L442.93 116.31L442.85 54.5599H429.06V97.8299C429.06 100.12 418.51 105.93 411.87 105.93C403.46 105.93 399.37 99.9899 399.37 87.7799V54.5499H385.55L385.58 88.2799C385.58 109.07 392.67 114.84 401.43 117.36C410.34 119.92 421.96 115.88 429.05 106.79V116.33H429.06ZM292.78 54.5599H278.93V116.27H292.78V54.5599Z"
        fill="black"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_192_1879"
        x1="5.48309"
        y1="25.8354"
        x2="185.256"
        y2="108.473"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#40EDD8" />
        <stop offset="0.0241" stopColor="#38E7E2" />
        <stop offset="0.0844" stopColor="#28DAF7" />
        <stop offset="0.1241" stopColor="#22D5FF" />
        <stop offset="0.3602" stopColor="#1ABFFF" />
        <stop offset="0.8502" stopColor="#0786FE" />
        <stop offset="0.9088" stopColor="#047FFE" />
      </linearGradient>
      <clipPath id="clip0_192_1879">
        <rect width="443" height="137" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
